import { formatHex, parse } from 'culori';

export const useTailwind = () => {
  const getTailwindColor = (varName: string) => {
    const oklchColor = getComputedStyle(document.documentElement).getPropertyValue(`--color-${varName}`);
    const parsedColor = parse(oklchColor);
    return formatHex(parsedColor) ?? 'red';
  };
  return { getTailwindColor };
};
